import {selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {suppliersStore} from '@store/suppliers/suppliers.store';
import {getSuppliersDataSource} from '@store/suppliers/suppliers.requests';

export class SuppliersQuery {
  store = suppliersStore;

  status$ = this.store.pipe(select((state) => state.status));
  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  suppliers$ = getSuppliersDataSource.data$();
  selectedSuppliers$ = this.store.pipe(
    selectManyByPredicate((supplierUI) => supplierUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const suppliersQuery = new SuppliersQuery();